import { CustomerType } from '../interfaces/common/customer';

export const emptyCustomer: CustomerType = {
  id: '',
  name: '',
  phone_number: '',
  email: '',
  locations: [],
  merchant: undefined,
  notifications_disabled: false,
};
